<template>
	<div class="grid grid-cols-8 gap-y-4 gap-x-6">
		<ui-input-group
			class="col-span-4"
			v-model="form.title"
			label="Title"
			:form="form"
			field="title"
			:required="true"
		/>

		<!--ui-input-group
            class="col-span-2"
            v-model="form.release_at"
            label="Veröffentlichung am"
            :form="form"
            field="release_at"
            :required="true"
        /-->

		<div class="col-span-2">
			<div class="text-gray-700 focus-within:text-orange-500">
				<div class="flex justify-between flex-wrap">
					<label class="block font-medium">Veröffentlichung am</label>
				</div>
				<div class="mt-1 relative">
					<datepicker
						v-model="form.release_date"
						@selected="setReleaseDate"
						input-class="text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md"
						format="dd.MM.yyyy"
					></datepicker>
				</div>
			</div>
			<ui-input-group
				class=""
				v-model="form.release_time"
				label="Uhrzeit"
				:form="form"
				field="release_time"
				:required="true"
				:type="'time'"
				@input="setReleaseTime"
			/>
		</div>

		<ui-textarea-group
			class="col-span-4"
			v-model="form.short_text"
			field="short_text"
			label="Kurz gesagt..."
			:form="form"
			:required="false"
			:rows="6"
			:maxWProse="false"
		/>

		<ui-check-group
			class="col-span-4"
			:form="form"
			field="active"
			v-model="form.active"
			label="Aktiv"
		/>
	</div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		let releaseDate = new Date(this.form.release_at);
		this.form.release_date =
			releaseDate.getFullYear() +
			"/" +
			padTo2Digits(releaseDate.getMonth() + 1) +
			"/" +
			padTo2Digits(releaseDate.getDate());
		this.form.release_time =
			padTo2Digits(releaseDate.getHours()) +
			":" +
			padTo2Digits(releaseDate.getMinutes());
		return {
			selectedReleaseDate: this.form.release_date,
		};
	},
	components: {
		Datepicker,
	},
	methods: {
		setReleaseDate(selectedDate) {
			let date = new Date(selectedDate);
			this.selectedReleaseDate = date;
			let newDateStr =
				date.getFullYear() +
				"-" +
				padTo2Digits(date.getMonth() + 1) +
				"-" +
				padTo2Digits(date.getDate()) +
				" " +
				this.form.release_time +
				":00";
			console.log(newDateStr);
			this.form.release_at = newDateStr;
		},
		setReleaseTime(selectedTime) {
			let date = new Date(this.selectedReleaseDate);
			let newDateStr =
				date.getFullYear() +
				"-" +
				padTo2Digits(date.getMonth() + 1) +
				"-" +
				padTo2Digits(date.getDate()) +
				" " +
				selectedTime +
				":00";
			console.log(newDateStr);
			this.form.release_at = newDateStr;
		},
	},
};
</script>
